/**
 * sz-26-cj270-sample-submit — 三步打样表单
 */
(function () {
  'use strict';

  var ALLOWED_EXT = ['stl', 'obj', '3mf', 'step', 'stp', 'glb', 'gltf', 'fbx', 'wrl'];
  var MAX_FILE_BYTES = 209715200;
  var MULTIPART_THRESHOLD_BYTES = 8 * 1024 * 1024;
  var MULTIPART_URL_BATCH_SIZE = 40;
  /** 全局 OSS 直传并发上限（浏览器同域名约 6 路；双文件共用，避免抢光连接导致另一个卡 0%） */
  var MULTIPART_CONCURRENCY = 6;
  var MULTIPART_RETRY_COUNT = 2;

  function createConcurrencyLimiter(limit) {
    var active = 0;
    var queue = [];
    var seq = 0;

    function pump() {
      if (active >= limit || !queue.length) return;
      queue.sort(function (a, b) {
        if (a.priority !== b.priority) return a.priority - b.priority;
        return a.seq - b.seq;
      });
      var job = queue.shift();
      active += 1;
      Promise.resolve()
        .then(job.fn)
        .then(job.resolve, job.reject)
        .then(function () {
          active -= 1;
          pump();
        });
    }

    /** @param {function(): Promise} fn @param {number} [priority] 数字越小越优先 */
    return function schedule(fn, priority) {
      return new Promise(function (resolve, reject) {
        queue.push({
          fn: fn,
          resolve: resolve,
          reject: reject,
          priority: priority == null ? 100 : Number(priority),
          seq: seq++
        });
        pump();
      });
    };
  }
  var SESSION_EXPIRED_CODES = { '1060000062': true, '1060000063': true };
  var UPGRADE_BLOCK_CODE = '1060000070';
  var FIELD_KEYS = {
    A: ['modelFile'],
    B: ['modelFile', 'modelFile2']
  };

  var COUNTRIES = [
    ['AF', 'Afghanistan'], ['AX', 'Åland Islands'], ['AL', 'Albania'], ['DZ', 'Algeria'],
    ['AS', 'American Samoa'], ['AD', 'Andorra'], ['AO', 'Angola'], ['AI', 'Anguilla'],
    ['AQ', 'Antarctica'], ['AG', 'Antigua and Barbuda'], ['AR', 'Argentina'], ['AM', 'Armenia'],
    ['AW', 'Aruba'], ['AU', 'Australia'], ['AT', 'Austria'], ['AZ', 'Azerbaijan'],
    ['BS', 'Bahamas'], ['BH', 'Bahrain'], ['BD', 'Bangladesh'], ['BB', 'Barbados'],
    ['BY', 'Belarus'], ['BE', 'Belgium'], ['BZ', 'Belize'], ['BJ', 'Benin'],
    ['BM', 'Bermuda'], ['BT', 'Bhutan'], ['BO', 'Bolivia'], ['BQ', 'Bonaire, Sint Eustatius and Saba'],
    ['BA', 'Bosnia and Herzegovina'], ['BW', 'Botswana'], ['BV', 'Bouvet Island'], ['BR', 'Brazil'],
    ['IO', 'British Indian Ocean Territory'], ['BN', 'Brunei Darussalam'], ['BG', 'Bulgaria'], ['BF', 'Burkina Faso'],
    ['BI', 'Burundi'], ['CV', 'Cabo Verde'], ['KH', 'Cambodia'], ['CM', 'Cameroon'],
    ['CA', 'Canada'], ['KY', 'Cayman Islands'], ['CF', 'Central African Republic'], ['TD', 'Chad'],
    ['CL', 'Chile'], ['CN', 'China'], ['CX', 'Christmas Island'], ['CC', 'Cocos (Keeling) Islands'],
    ['CO', 'Colombia'], ['KM', 'Comoros'], ['CG', 'Congo'], ['CD', 'Congo, Democratic Republic of the'],
    ['CK', 'Cook Islands'], ['CR', 'Costa Rica'], ['CI', "Côte d'Ivoire"], ['HR', 'Croatia'],
    ['CU', 'Cuba'], ['CW', 'Curaçao'], ['CY', 'Cyprus'], ['CZ', 'Czechia'],
    ['DK', 'Denmark'], ['DJ', 'Djibouti'], ['DM', 'Dominica'], ['DO', 'Dominican Republic'],
    ['EC', 'Ecuador'], ['EG', 'Egypt'], ['SV', 'El Salvador'], ['GQ', 'Equatorial Guinea'],
    ['ER', 'Eritrea'], ['EE', 'Estonia'], ['SZ', 'Eswatini'], ['ET', 'Ethiopia'],
    ['FK', 'Falkland Islands'], ['FO', 'Faroe Islands'], ['FJ', 'Fiji'], ['FI', 'Finland'],
    ['FR', 'France'], ['GF', 'French Guiana'], ['PF', 'French Polynesia'], ['TF', 'French Southern Territories'],
    ['GA', 'Gabon'], ['GM', 'Gambia'], ['GE', 'Georgia'], ['DE', 'Germany'],
    ['GH', 'Ghana'], ['GI', 'Gibraltar'], ['GR', 'Greece'], ['GL', 'Greenland'],
    ['GD', 'Grenada'], ['GP', 'Guadeloupe'], ['GU', 'Guam'], ['GT', 'Guatemala'],
    ['GG', 'Guernsey'], ['GN', 'Guinea'], ['GW', 'Guinea-Bissau'], ['GY', 'Guyana'],
    ['HT', 'Haiti'], ['HM', 'Heard Island and McDonald Islands'], ['VA', 'Holy See'], ['HN', 'Honduras'],
    ['HK', 'Hong Kong'], ['HU', 'Hungary'], ['IS', 'Iceland'], ['IN', 'India'],
    ['ID', 'Indonesia'], ['IR', 'Iran'], ['IQ', 'Iraq'], ['IE', 'Ireland'],
    ['IM', 'Isle of Man'], ['IL', 'Israel'], ['IT', 'Italy'], ['JM', 'Jamaica'],
    ['JP', 'Japan'], ['JE', 'Jersey'], ['JO', 'Jordan'], ['KZ', 'Kazakhstan'],
    ['KE', 'Kenya'], ['KI', 'Kiribati'], ['KP', "Korea, Democratic People's Republic of"], ['KR', 'Korea, Republic of'],
    ['KW', 'Kuwait'], ['KG', 'Kyrgyzstan'], ['LA', 'Lao People\'s Democratic Republic'], ['LV', 'Latvia'],
    ['LB', 'Lebanon'], ['LS', 'Lesotho'], ['LR', 'Liberia'], ['LY', 'Libya'],
    ['LI', 'Liechtenstein'], ['LT', 'Lithuania'], ['LU', 'Luxembourg'], ['MO', 'Macao'],
    ['MG', 'Madagascar'], ['MW', 'Malawi'], ['MY', 'Malaysia'], ['MV', 'Maldives'],
    ['ML', 'Mali'], ['MT', 'Malta'], ['MH', 'Marshall Islands'], ['MQ', 'Martinique'],
    ['MR', 'Mauritania'], ['MU', 'Mauritius'], ['YT', 'Mayotte'], ['MX', 'Mexico'],
    ['FM', 'Micronesia'], ['MD', 'Moldova'], ['MC', 'Monaco'], ['MN', 'Mongolia'],
    ['ME', 'Montenegro'], ['MS', 'Montserrat'], ['MA', 'Morocco'], ['MZ', 'Mozambique'],
    ['MM', 'Myanmar'], ['NA', 'Namibia'], ['NR', 'Nauru'], ['NP', 'Nepal'],
    ['NL', 'Netherlands'], ['NC', 'New Caledonia'], ['NZ', 'New Zealand'], ['NI', 'Nicaragua'],
    ['NE', 'Niger'], ['NG', 'Nigeria'], ['NU', 'Niue'], ['NF', 'Norfolk Island'],
    ['MK', 'North Macedonia'], ['MP', 'Northern Mariana Islands'], ['NO', 'Norway'], ['OM', 'Oman'],
    ['PK', 'Pakistan'], ['PW', 'Palau'], ['PS', 'Palestine, State of'], ['PA', 'Panama'],
    ['PG', 'Papua New Guinea'], ['PY', 'Paraguay'], ['PE', 'Peru'], ['PH', 'Philippines'],
    ['PN', 'Pitcairn'], ['PL', 'Poland'], ['PT', 'Portugal'], ['PR', 'Puerto Rico'],
    ['QA', 'Qatar'], ['RE', 'Réunion'], ['RO', 'Romania'], ['RU', 'Russian Federation'],
    ['RW', 'Rwanda'], ['BL', 'Saint Barthélemy'], ['SH', 'Saint Helena'], ['KN', 'Saint Kitts and Nevis'],
    ['LC', 'Saint Lucia'], ['MF', 'Saint Martin'], ['PM', 'Saint Pierre and Miquelon'], ['VC', 'Saint Vincent and the Grenadines'],
    ['WS', 'Samoa'], ['SM', 'San Marino'], ['ST', 'Sao Tome and Principe'], ['SA', 'Saudi Arabia'],
    ['SN', 'Senegal'], ['RS', 'Serbia'], ['SC', 'Seychelles'], ['SL', 'Sierra Leone'],
    ['SG', 'Singapore'], ['SX', 'Sint Maarten'], ['SK', 'Slovakia'], ['SI', 'Slovenia'],
    ['SB', 'Solomon Islands'], ['SO', 'Somalia'], ['ZA', 'South Africa'], ['GS', 'South Georgia and the South Sandwich Islands'],
    ['SS', 'South Sudan'], ['ES', 'Spain'], ['LK', 'Sri Lanka'], ['SD', 'Sudan'],
    ['SR', 'Suriname'], ['SJ', 'Svalbard and Jan Mayen'], ['SE', 'Sweden'], ['CH', 'Switzerland'],
    ['SY', 'Syrian Arab Republic'], ['TW', 'Taiwan'], ['TJ', 'Tajikistan'], ['TZ', 'Tanzania'],
    ['TH', 'Thailand'], ['TL', 'Timor-Leste'], ['TG', 'Togo'], ['TK', 'Tokelau'],
    ['TO', 'Tonga'], ['TT', 'Trinidad and Tobago'], ['TN', 'Tunisia'], ['TR', 'Türkiye'],
    ['TM', 'Turkmenistan'], ['TC', 'Turks and Caicos Islands'], ['TV', 'Tuvalu'], ['UG', 'Uganda'],
    ['UA', 'Ukraine'], ['AE', 'United Arab Emirates'], ['GB', 'United Kingdom'], ['US', 'United States'],
    ['UM', 'United States Minor Outlying Islands'], ['UY', 'Uruguay'], ['UZ', 'Uzbekistan'], ['VU', 'Vanuatu'],
    ['VE', 'Venezuela'], ['VN', 'Viet Nam'], ['VG', 'Virgin Islands, British'], ['VI', 'Virgin Islands, U.S.'],
    ['WF', 'Wallis and Futuna'], ['EH', 'Western Sahara'], ['YE', 'Yemen'], ['ZM', 'Zambia'], ['ZW', 'Zimbabwe']
  ];

  function q(root, sel) {
    return root.querySelector(sel);
  }

  function qa(root, sel) {
    return Array.prototype.slice.call(root.querySelectorAll(sel));
  }

  function fileExt(name) {
    var parts = String(name || '').split('.');
    return parts.length > 1 ? parts.pop().toLowerCase() : '';
  }

  function resolveMime(file) {
    if (file && file.type) return file.type;
    return 'application/octet-stream';
  }

  function envelopeMsg(result, fallback) {
    var body = result && result.body ? result.body : result;
    if (body && body.msg) return String(body.msg);
    return fallback || 'Something went wrong. Please try again.';
  }

  function envelopeCode(result) {
    var body = result && result.body ? result.body : result;
    return body && body.code != null ? String(body.code) : '';
  }

  function init(root) {
    if (!root || root.dataset.cj270Ready === 'true') return;
    // UI（店铺下拉等）不依赖 API；缺 API 时仍要能点开下拉，请求时再取
    root.dataset.cj270Ready = 'true';

    function api() {
      return globalApi();
    }

    function requireApi() {
      var a = api();
      if (a) return a;
      setBanner((config && config.errNetwork) || 'Service unavailable. Please refresh and try again.');
      return null;
    }

    var config = {};
    var configEl = q(root, '[data-cj270-config]');
    if (configEl) {
      try {
        config = JSON.parse(configEl.textContent);
      } catch (e) {
        config = {};
      }
    }

    var form = q(root, '[data-cj270-form]');
    var banner = q(root, '[data-cj270-banner]');
    var storeInput = q(root, '[data-cj270-field="store"]');
    var storeTrigger = q(root, '[data-cj270-store-trigger]');
    var storeLabel = q(root, '[data-cj270-store-label]');
    var storePanel = q(root, '[data-cj270-store-panel]');
    var storeWrap = q(root, '[data-cj270-store]');
    var storeOptions = qa(root, '[data-cj270-store-option]');
    var countryInput = q(root, '[data-cj270-field="country"]');
    var countryWrap = q(root, '[data-cj270-country]');
    var countryTrigger = q(root, '[data-cj270-country-trigger]');
    var countryLabel = q(root, '[data-cj270-country-label]');
    var countryPanel = q(root, '[data-cj270-country-panel]');
    var countryList = q(root, '[data-cj270-country-list]');
    var countrySearch = q(root, '[data-cj270-country-search]');
    var confirmBtn = q(root, '[data-cj270-confirm]');
    var acceptBtn = q(root, '[data-cj270-accept]');
    var agreeBoxes = qa(root, '[data-cj270-agree]');
    var successModal = q(root, '[data-cj270-success-modal]');
    var backBtns = qa(root, '[data-cj270-back]');
    var submitBtn = q(root, '[data-cj270-submit]');
    var uploadsWrap = q(root, '[data-cj270-uploads]');
    var companyLabelA = q(root, '[data-cj270-company-label-a]');
    var companyLabelB = q(root, '[data-cj270-company-label-b]');
    var uploadLabelA = q(root, '[data-cj270-upload-label-a]');
    var uploadLabelB = q(root, '[data-cj270-upload-label-b]');
    var storePlaceholder = (storeLabel && storeLabel.textContent) || 'Select region / site';
    var countryPlaceholder = (countryLabel && countryLabel.textContent) || config.countryPlaceholder || 'Country / Region';
    var countryOptions = [];

    var session = {
      authToken: '',
      orderEmail: '',
      storeCode: '',
      benefitType: '',
      expireAt: 0
    };
    var selectedFiles = {
      modelFile: null,
      modelFile2: null
    };
    var multipartUploads = {
      modelFile: null,
      modelFile2: null
    };
    /** 双文件并行时共用连接池，两边进度一起走 */
    var scheduleOssUpload = createConcurrencyLimiter(MULTIPART_CONCURRENCY);
    var currentStep = 1;
    var busy = false;
    /** 每次 Submit 递增；失败/取消后丢弃迟到的 onprogress，避免把已清掉的进度又刷回来 */
    var uploadRunId = 0;

    function getHeaders() {
      var headers = {};
      if (root.dataset.tenantId) headers.tenantId = root.dataset.tenantId;
      return headers;
    }

    function setBanner(msg) {
      if (!banner) return;
      if (msg) {
        banner.textContent = msg;
        banner.hidden = false;
      } else {
        banner.textContent = '';
        banner.hidden = true;
      }
    }

    function setFieldError(name, msg) {
      var el = q(root, '[data-cj270-error="' + name + '"]');
      if (!el) return;
      if (msg) {
        el.textContent = msg;
        el.hidden = false;
      } else {
        el.textContent = '';
        el.hidden = true;
      }
    }

    function clearErrors() {
      setBanner('');
      qa(root, '[data-cj270-error]').forEach(function (el) {
        el.textContent = '';
        el.hidden = true;
      });
    }

    function setStep(step) {
      currentStep = step;
      root.setAttribute('data-step', String(step));
      qa(root, '[data-cj270-panel]').forEach(function (panel) {
        var n = Number(panel.getAttribute('data-cj270-panel'));
        var show = n === step;
        panel.hidden = !show;
        if (show) panel.removeAttribute('hidden');
        else panel.setAttribute('hidden', '');
      });
      qa(root, '[data-cj270-step]').forEach(function (item) {
        var n = Number(item.getAttribute('data-cj270-step'));
        var active = step <= 3 && n === step;
        item.classList.toggle('is-active', active);
        item.classList.toggle('is-done', n < step);
      });
      if (step === 1) {
        closeStore();
        closeCountry();
        hideSuccessModal();
      }
      if (step === 2 || step === 3) applyBenefitUI();
    }

    function isBenefitB() {
      return session.benefitType === 'B';
    }

    function activeFieldKeys() {
      // 权益 B：两个模型附件均为必填，始终走双槽上传
      return isBenefitB() ? FIELD_KEYS.B.slice() : FIELD_KEYS.A.slice();
    }

    function visibleAgreeBoxes() {
      var benefit = String(root.getAttribute('data-benefit') || session.benefitType || '').toUpperCase();
      return agreeBoxes.filter(function (box) {
        var host = box.closest('[data-cj270-benefit-only]');
        if (!host) return false;
        var only = String(host.getAttribute('data-cj270-benefit-only') || '').toUpperCase();
        return !!benefit && only === benefit;
      });
    }

    function allAgreesChecked() {
      var boxes = visibleAgreeBoxes();
      if (!boxes.length) return false;
      return boxes.every(function (box) {
        return !!box.checked;
      });
    }

    function clearAgreeBoxes() {
      agreeBoxes.forEach(function (box) {
        box.checked = false;
      });
    }

    function applyBenefitUI() {
      var raw = String(session.benefitType || '').trim().toUpperCase();
      var benefit = raw === 'B' ? 'B' : raw === 'A' ? 'A' : '';
      session.benefitType = benefit;
      root.setAttribute('data-benefit', benefit);
      root.classList.toggle('is-benefit-a', benefit === 'A');
      root.classList.toggle('is-benefit-b', benefit === 'B');

      qa(root, '[data-cj270-benefit-only]').forEach(function (el) {
        var only = String(el.getAttribute('data-cj270-benefit-only') || '').toUpperCase();
        var show = !!benefit && only === benefit;
        if (show) {
          el.removeAttribute('hidden');
          el.hidden = false;
        } else {
          el.setAttribute('hidden', '');
          el.hidden = true;
        }
      });

      if (companyLabelA) {
        companyLabelA.hidden = benefit === 'B';
        if (benefit === 'B') companyLabelA.setAttribute('hidden', '');
        else companyLabelA.removeAttribute('hidden');
      }
      if (companyLabelB) {
        companyLabelB.hidden = benefit !== 'B';
        if (benefit === 'B') companyLabelB.removeAttribute('hidden');
        else companyLabelB.setAttribute('hidden', '');
      }
      if (uploadLabelA) {
        uploadLabelA.hidden = benefit === 'B';
        if (benefit === 'B') uploadLabelA.setAttribute('hidden', '');
        else uploadLabelA.removeAttribute('hidden');
      }
      if (uploadLabelB) {
        uploadLabelB.hidden = benefit !== 'B';
        if (benefit === 'B') uploadLabelB.removeAttribute('hidden');
        else uploadLabelB.setAttribute('hidden', '');
      }
      if (uploadsWrap) uploadsWrap.classList.toggle('is-benefit-b', benefit === 'B');
      var slot2 = q(root, '[data-cj270-upload-slot="modelFile2"]');
      if (slot2) {
        if (benefit === 'B') {
          slot2.removeAttribute('hidden');
          slot2.hidden = false;
        } else {
          slot2.setAttribute('hidden', '');
          slot2.hidden = true;
        }
      }
      if (benefit !== 'B') {
        setFile('modelFile2', null);
        var file2 = q(root, '[data-cj270-file-input="modelFile2"]');
        if (file2) file2.value = '';
      }
      syncAgreeButton();
    }

    function progressEls(fieldKey) {
      return {
        wrap: q(root, '[data-cj270-progress="' + fieldKey + '"]'),
        text: q(root, '[data-cj270-progress-text="' + fieldKey + '"]'),
        pct: q(root, '[data-cj270-progress-pct="' + fieldKey + '"]'),
        bar: q(root, '[data-cj270-progress-bar="' + fieldKey + '"]')
      };
    }

    function resetSession() {
      abortAllMultipart();
      session.authToken = '';
      session.orderEmail = '';
      session.storeCode = '';
      session.benefitType = '';
      session.expireAt = 0;
      applyBenefitUI();
    }

    function sessionExpired() {
      return !session.authToken || Date.now() >= session.expireAt;
    }

    function handleExpired(result) {
      if (SESSION_EXPIRED_CODES[envelopeCode(result)]) {
        resetSession();
        setStep(1);
        setBanner(envelopeMsg(result, 'Your session has expired. Please verify your email again.'));
        return true;
      }
      return false;
    }

    function setStoreSelection(value, label) {
      if (storeInput) storeInput.value = value || '';
      if (storeLabel) {
        if (value) {
          storeLabel.textContent = label || value;
          storeLabel.classList.remove('is-placeholder');
        } else {
          storeLabel.textContent = storePlaceholder;
          storeLabel.classList.add('is-placeholder');
        }
      }
      storeOptions.forEach(function (opt) {
        opt.classList.toggle('is-selected', opt.dataset.value === value);
      });
      if (value !== session.storeCode) resetSession();
    }

    function closeStore() {
      if (!storeWrap || !storeTrigger || !storePanel) return;
      storeWrap.classList.remove('is-open');
      root.classList.remove('is-store-open');
      storeTrigger.setAttribute('aria-expanded', 'false');
      storePanel.hidden = true;
    }

    function toggleStore() {
      if (!storeWrap || !storeTrigger || !storePanel) return;
      var open = !storeWrap.classList.contains('is-open');
      if (open) closeCountry();
      storeWrap.classList.toggle('is-open', open);
      root.classList.toggle('is-store-open', open);
      storeTrigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      storePanel.hidden = !open;
    }

    function setCountrySelection(value, label) {
      if (countryInput) countryInput.value = value || '';
      if (countryLabel) {
        if (value) {
          countryLabel.textContent = label || value;
          countryLabel.classList.remove('is-placeholder');
        } else {
          countryLabel.textContent = countryPlaceholder;
          countryLabel.classList.add('is-placeholder');
        }
      }
      countryOptions.forEach(function (opt) {
        opt.classList.toggle('is-selected', opt.dataset.value === value);
      });
    }

    function closeCountry() {
      if (!countryWrap || !countryTrigger || !countryPanel) return;
      countryWrap.classList.remove('is-open');
      root.classList.remove('is-country-open');
      countryTrigger.setAttribute('aria-expanded', 'false');
      countryPanel.hidden = true;
    }

    function openCountry() {
      if (!countryWrap || !countryTrigger || !countryPanel) return;
      closeStore();
      countryWrap.classList.add('is-open');
      root.classList.add('is-country-open');
      countryTrigger.setAttribute('aria-expanded', 'true');
      countryPanel.hidden = false;
      if (countrySearch) {
        countrySearch.value = '';
        filterCountries('');
        window.setTimeout(function () {
          countrySearch.focus();
        }, 0);
      }
    }

    function toggleCountry() {
      if (!countryWrap) return;
      if (countryWrap.classList.contains('is-open')) closeCountry();
      else openCountry();
    }

    function filterCountries(query) {
      if (!countryList) return;
      var raw = String(query || '').trim();
      var qstr = raw.toLowerCase();
      var visible = 0;
      countryOptions.forEach(function (opt) {
        var label = (opt.dataset.label || opt.textContent || '').toLowerCase();
        var code = (opt.dataset.value || '').toLowerCase();
        var show = !qstr || label.indexOf(qstr) !== -1 || code.indexOf(qstr) !== -1;
        if (show) {
          opt.removeAttribute('hidden');
          visible += 1;
        } else {
          opt.setAttribute('hidden', '');
        }
      });
      updateCustomCountryOption(raw, visible);
    }

    function updateCustomCountryOption(raw, visible) {
      if (!countryList) return;
      var custom = q(countryList, '[data-cj270-country-custom]');
      var emptyEl = q(countryList, '[data-cj270-country-empty]');
      var showCustom = !!raw && visible === 0;

      if (emptyEl) emptyEl.setAttribute('hidden', '');

      if (!showCustom) {
        if (custom) custom.setAttribute('hidden', '');
        return;
      }

      if (!custom) {
        custom = document.createElement('button');
        custom.type = 'button';
        custom.className = 'sz-26-cj270-sample__store-option sz-26-cj270-sample__country-custom';
        custom.setAttribute('role', 'option');
        custom.setAttribute('data-cj270-country-custom', '');
        custom.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var value = custom.dataset.value || '';
          var label = custom.dataset.label || value;
          if (!value) return;
          setCountrySelection(value, label);
          closeCountry();
          setFieldError('country', '');
        });
        countryList.appendChild(custom);
      }
      custom.dataset.value = raw;
      custom.dataset.label = raw;
      custom.textContent = raw;
      custom.removeAttribute('hidden');
    }

    function selectFirstVisibleCountry() {
      var custom = countryList && q(countryList, '[data-cj270-country-custom]');
      if (custom && !custom.hasAttribute('hidden')) {
        custom.click();
        return;
      }
      var first = countryOptions.find(function (opt) {
        return !opt.hasAttribute('hidden');
      });
      if (first) first.click();
    }

    function fillCountries(listEl) {
      if (!listEl) return;
      listEl.innerHTML = '';
      countryOptions = [];
      COUNTRIES.forEach(function (item) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'sz-26-cj270-sample__store-option';
        btn.setAttribute('role', 'option');
        btn.setAttribute('data-cj270-country-option', '');
        btn.dataset.value = item[0];
        btn.dataset.label = item[1];
        btn.textContent = item[1];
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          setCountrySelection(item[0], item[1]);
          closeCountry();
          setFieldError('country', '');
        });
        listEl.appendChild(btn);
        countryOptions.push(btn);
      });
    }

    fillCountries(countryList);

    function setFile(fieldKey, file) {
      var prev = selectedFiles[fieldKey];
      if (file !== prev) {
        if (multipartUploads[fieldKey] && !multipartUploads[fieldKey].completed) {
          abortCurrentMultipart(fieldKey);
        } else {
          multipartUploads[fieldKey] = null;
        }
      }
      selectedFiles[fieldKey] = file || null;
      var fileNameEl = q(root, '[data-cj270-file-name="' + fieldKey + '"]');
      if (fileNameEl) {
        if (file) {
          fileNameEl.textContent = file.name;
          fileNameEl.removeAttribute('hidden');
          fileNameEl.hidden = false;
        } else {
          fileNameEl.textContent = '';
          fileNameEl.setAttribute('hidden', '');
          fileNameEl.hidden = true;
        }
      }
      var dropzone = q(root, '[data-cj270-dropzone="' + fieldKey + '"]');
      if (dropzone) dropzone.classList.toggle('has-file', !!file);
    }

    function validateFile(file, requiredMsg) {
      if (!file) return requiredMsg || config.errFileRequired || 'Please upload your 3D model file.';
      var ext = fileExt(file.name);
      if (ALLOWED_EXT.indexOf(ext) === -1) {
        return config.errFileType || 'Please upload a valid 3D model file.';
      }
      if (file.size > MAX_FILE_BYTES) {
        return config.errFileSize || 'Please upload a valid 3D model file.';
      }
      return '';
    }

    function fileFingerprint(file) {
      if (!file) return '';
      return String(file.name || '') + '::' + String(file.size || 0);
    }

    function fieldValue(name) {
      var el = q(root, '[data-cj270-field="' + name + '"]');
      return el ? String(el.value || '').trim() : '';
    }

    function validateEmail(value) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    }

    function setBusy(next, opts) {
      busy = next;
      if (confirmBtn) confirmBtn.disabled = next;
      if (submitBtn) submitBtn.disabled = next;
      qa(root, '[data-cj270-file-input]').forEach(function (input) {
        input.disabled = next;
      });
      backBtns.forEach(function (btn) {
        btn.disabled = next;
      });
      root.classList.toggle('is-busy', next);
      // 失败时保留进度条，方便看到哪个已传完、哪个失败
      if (!next && !(opts && opts.keepProgress)) hideProgress();
      syncAgreeButton();
    }

    function hideProgress(fieldKey) {
      var keys = fieldKey ? [fieldKey] : ['modelFile', 'modelFile2'];
      keys.forEach(function (key) {
        var els = progressEls(key);
        if (els.wrap) els.wrap.hidden = true;
        if (els.bar) els.bar.style.width = '0%';
        if (els.pct) els.pct.textContent = '';
        if (els.text) els.text.textContent = '';
      });
    }

    function showProgress(fieldKey, label, percent, runId) {
      if (runId != null && runId !== uploadRunId) return;
      var els = progressEls(fieldKey);
      if (!els.wrap) return;
      var pct = Math.max(0, Math.min(100, Math.round(percent || 0)));
      els.wrap.hidden = false;
      if (els.text) els.text.textContent = label;
      if (els.pct) els.pct.textContent = pct + '%';
      if (els.bar) els.bar.style.width = pct + '%';
    }

    function warnLeave(e) {
      if (!busy) return;
      e.preventDefault();
      e.returnValue = '';
    }

    function syncAgreeButton() {
      if (!acceptBtn) return;
      acceptBtn.disabled = busy || !allAgreesChecked();
    }

    function showSuccessModal() {
      if (!successModal) return;
      successModal.hidden = false;
      successModal.removeAttribute('inert');
      successModal.setAttribute('aria-hidden', 'false');
      successModal.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      var closeBtn = q(successModal, '.sz-26-cj270-sample__modal-close');
      if (closeBtn) closeBtn.focus();
    }

    function hideSuccessModal() {
      if (!successModal) return;
      successModal.classList.remove('is-open');
      successModal.hidden = true;
      successModal.setAttribute('inert', '');
      successModal.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    }

    function onAccept() {
      if (busy) return;
      clearErrors();
      if (sessionExpired()) {
        resetSession();
        setStep(1);
        setBanner(config.errExpired || 'Your session has expired. Please verify your email again.');
        return;
      }
      if (!allAgreesChecked()) {
        setFieldError('agree', config.errAgree || 'Please read and agree to the agreement before continuing.');
        syncAgreeButton();
        return;
      }
      setStep(3);
    }

    function onConfirm() {
      if (busy) return;
      if (!requireApi()) return;
      clearErrors();
      var email = fieldValue('orderEmail');
      var storeCode = storeInput ? storeInput.value : '';
      var ok = true;
      if (!validateEmail(email)) {
        setFieldError('orderEmail', config.errEmail || 'Please enter a valid email address.');
        ok = false;
      }
      if (!storeCode) {
        setFieldError('store', config.errStore || 'Please select a reward store.');
        ok = false;
      }
      if (!ok) return;

      setBusy(true);
      api().authSample(root.dataset.apiBase || '', {
        orderEmail: email,
        storeCode: storeCode
      }, getHeaders()).then(function (res) {
        setBusy(false);
        var code = envelopeCode(res);
        if (code === UPGRADE_BLOCK_CODE) {
          setBanner(envelopeMsg(res, config.errUpgrade));
          return;
        }
        if (!api().isSuccess(res) || !res.body || !res.body.data) {
          setBanner(envelopeMsg(res));
          return;
        }
        var data = res.body.data || {};
        var benefitType = String(
          data.benefitType != null ? data.benefitType : (data.benefit_type != null ? data.benefit_type : '')
        ).trim().toUpperCase();
        if (benefitType !== 'A' && benefitType !== 'B') {
          setBanner(config.errBenefit || 'Unable to determine your package. Please contact customer support.');
          return;
        }
        session.authToken = data.authToken;
        session.orderEmail = data.orderEmail || email;
        session.storeCode = data.storeCode || storeCode;
        session.benefitType = benefitType;
        session.expireAt = Date.now() + (Number(data.expireSeconds || 1800) * 1000);
        clearAgreeBoxes();
        applyBenefitUI();
        var contact = q(root, '[data-cj270-field="contactEmail"]');
        if (contact && !contact.value) contact.value = session.orderEmail;
        setStep(2);
        // 再次强制应用，防止 setStep / 其他逻辑覆盖
        session.benefitType = benefitType;
        applyBenefitUI();
      }).catch(function () {
        setBusy(false);
        setBanner(config.errNetwork || 'Network error. Please try again.');
      });
    }

    function validateStep2() {
      var ok = true;
      var fullName = fieldValue('fullName');
      var contactEmail = fieldValue('contactEmail');
      var companyName = fieldValue('companyName');
      var countryCode = fieldValue('country');
      var addressLine1 = fieldValue('addressLine1');
      var city = fieldValue('city');
      var stateProvince = fieldValue('stateProvince');
      var postalCode = fieldValue('postalCode');
      if (!fullName) {
        setFieldError('fullName', config.errRequired || 'This field is required.');
        ok = false;
      }
      if (!validateEmail(contactEmail)) {
        setFieldError('contactEmail', config.errEmail || 'Please enter a valid email address.');
        ok = false;
      }
      if (isBenefitB() && !companyName) {
        setFieldError('companyName', config.errCompanyRequired || 'Please enter your company name.');
        ok = false;
      }
      if (!countryCode) {
        setFieldError('country', config.errRequired || 'This field is required.');
        ok = false;
      }
      if (!addressLine1) {
        setFieldError('addressLine1', config.errRequired || 'This field is required.');
        ok = false;
      }
      if (!city) {
        setFieldError('city', config.errRequired || 'This field is required.');
        ok = false;
      }
      if (!stateProvince) {
        setFieldError('stateProvince', config.errRequired || 'This field is required.');
        ok = false;
      }
      if (!postalCode) {
        setFieldError('postalCode', config.errRequired || 'This field is required.');
        ok = false;
      }
      var fileErr = validateFile(selectedFiles.modelFile);
      if (fileErr) {
        setFieldError('file', fileErr);
        ok = false;
      }
      if (isBenefitB()) {
        var file2Err = validateFile(
          selectedFiles.modelFile2,
          config.errFile2Required || 'Please upload 3D Model File 2.'
        );
        if (file2Err) {
          setFieldError('file2', file2Err);
          ok = false;
        } else if (
          selectedFiles.modelFile &&
          fileFingerprint(selectedFiles.modelFile) === fileFingerprint(selectedFiles.modelFile2)
        ) {
          setFieldError('file2', config.errFilesDifferent || 'Please upload two different model files.');
          ok = false;
        }
      }
      return ok;
    }

    function apiError(result, fallback) {
      var error = new Error(envelopeMsg(result, fallback));
      error.apiResult = result;
      return error;
    }

    function uploadSessionPayload() {
      return {
        authToken: session.authToken,
        storeCode: session.storeCode,
        orderEmail: session.orderEmail
      };
    }

    function fileMetadata(file, mime) {
      return {
        name: file.name,
        type: mime,
        size: file.size
      };
    }

    function abortCurrentMultipart(fieldKey) {
      var active = multipartUploads[fieldKey];
      multipartUploads[fieldKey] = null;
      if (!active || !active.uploadToken || active.completed) return Promise.resolve();
      var client = api();
      if (!client) return Promise.resolve();

      var body = uploadSessionPayload();
      body.uploadToken = active.uploadToken;
      return client.abortMultipart(root.dataset.apiBase || '', body, getHeaders()).catch(function () {
        return null;
      });
    }

    function abortAllMultipart() {
      return Promise.all(
        Object.keys(multipartUploads).map(function (key) {
          if (multipartUploads[key] && !multipartUploads[key].completed) {
            return abortCurrentMultipart(key);
          }
          multipartUploads[key] = null;
          return Promise.resolve();
        })
      );
    }

    function requestAllMultipartUrls(uploadToken, totalParts) {
      var partNumbers = [];
      var batches = [];
      var urls = [];
      var i;

      for (i = 1; i <= totalParts; i += 1) partNumbers.push(i);
      for (i = 0; i < partNumbers.length; i += MULTIPART_URL_BATCH_SIZE) {
        batches.push(partNumbers.slice(i, i + MULTIPART_URL_BATCH_SIZE));
      }

      return batches.reduce(function (chain, batch) {
        return chain.then(function () {
          var body = uploadSessionPayload();
          body.uploadToken = uploadToken;
          body.partNumbers = batch;
          return api().requestMultipartParts(root.dataset.apiBase || '', body, getHeaders());
        }).then(function (res) {
          var data = res && res.body && res.body.data;
          if (!api().isSuccess(res) || !data || !Array.isArray(data.parts)) {
            throw apiError(res, 'Unable to prepare multipart upload.');
          }
          data.parts.forEach(function (part) {
            urls.push({
              partNumber: Number(part.partNumber),
              uploadUrl: String(part.uploadUrl || '')
            });
          });
        });
      }, Promise.resolve()).then(function () {
        var seen = {};
        urls.forEach(function (part) {
          if (
            !Number.isInteger(part.partNumber) ||
            part.partNumber < 1 ||
            part.partNumber > totalParts ||
            !part.uploadUrl ||
            seen[part.partNumber]
          ) {
            throw new Error('Invalid multipart upload URL response.');
          }
          seen[part.partNumber] = true;
        });
        if (urls.length !== totalParts) {
          throw new Error('Some multipart upload URLs are missing.');
        }
        return urls.sort(function (a, b) {
          return a.partNumber - b.partNumber;
        });
      });
    }

    function uploadMultipartParts(fieldKey, file, partSize, parts, concurrency, runId) {
      var nextIndex = 0;
      var loadedByPart = {};
      var completedParts = [];
      var label = config.progressUploading || 'Uploading your model… Large files may take several minutes.';
      var maxWorkers = Math.max(1, Number(concurrency) || MULTIPART_CONCURRENCY);

      function updateProgress(partNumber, loaded) {
        loadedByPart[partNumber] = loaded;
        var totalLoaded = Object.keys(loadedByPart).reduce(function (sum, key) {
          return sum + Number(loadedByPart[key] || 0);
        }, 0);
        showProgress(fieldKey, label, file.size ? (totalLoaded / file.size) * 100 : 0, runId);
      }

      function uploadOne(part, attempt) {
        var start = (part.partNumber - 1) * partSize;
        var end = Math.min(start + partSize, file.size);
        var blob = file.slice(start, end);
        // modelFile（必填）优先占用连接
        var priority = fieldKey === 'modelFile' ? 0 : 1;
        updateProgress(part.partNumber, 0);
        return scheduleOssUpload(function () {
          if (runId != null && runId !== uploadRunId) {
            return Promise.reject(new Error('Upload cancelled'));
          }
          return api().uploadMultipartPart(part.uploadUrl, blob, function (loaded) {
            updateProgress(part.partNumber, Math.min(Number(loaded || 0), blob.size));
          });
        }, priority).then(function (result) {
          updateProgress(part.partNumber, blob.size);
          completedParts.push({
            partNumber: part.partNumber,
            etag: result.etag
          });
        }).catch(function (error) {
          var etagUnavailable =
            error && String(error.message || '').indexOf('ETag response header') !== -1;
          if (!etagUnavailable && attempt < MULTIPART_RETRY_COUNT) {
            return uploadOne(part, attempt + 1);
          }
          throw error;
        });
      }

      function worker() {
        if (nextIndex >= parts.length) return Promise.resolve();
        var part = parts[nextIndex];
        nextIndex += 1;
        return uploadOne(part, 0).then(worker);
      }

      var workers = [];
      var workerCount = Math.min(maxWorkers, parts.length);
      for (var i = 0; i < workerCount; i += 1) workers.push(worker());
      return Promise.all(workers).then(function () {
        return completedParts.sort(function (a, b) {
          return a.partNumber - b.partNumber;
        });
      });
    }

    function uploadMultipartFile(fieldKey, file, mime, concurrency, runId) {
      var current = multipartUploads[fieldKey];
      if (current && current.file === file && current.completed) {
        return Promise.resolve(current.uploadToken);
      }

      return abortCurrentMultipart(fieldKey).then(function () {
        var body = uploadSessionPayload();
        body.file = fileMetadata(file, mime);
        body.fieldKey = fieldKey;
        return api().initMultipart(root.dataset.apiBase || '', body, getHeaders());
      }).then(function (res) {
        var data = res && res.body && res.body.data;
        if (!api().isSuccess(res) || !data) {
          throw apiError(res, 'Unable to initialize multipart upload.');
        }
        var partSize = Number(data.partSize);
        var totalParts = Number(data.totalParts);
        if (
          !data.uploadToken ||
          !Number.isInteger(partSize) ||
          partSize <= 0 ||
          !Number.isInteger(totalParts) ||
          totalParts <= 0
        ) {
          throw new Error('Invalid multipart initialization response.');
        }
        multipartUploads[fieldKey] = {
          file: file,
          uploadToken: String(data.uploadToken),
          completed: false
        };
        return requestAllMultipartUrls(multipartUploads[fieldKey].uploadToken, totalParts).then(function (parts) {
          return uploadMultipartParts(fieldKey, file, partSize, parts, concurrency, runId);
        }).then(function (completedParts) {
          var completeBody = uploadSessionPayload();
          completeBody.uploadToken = multipartUploads[fieldKey].uploadToken;
          completeBody.parts = completedParts;
          return api().completeMultipart(
            root.dataset.apiBase || '',
            completeBody,
            getHeaders()
          );
        }).then(function (completeRes) {
          if (!api().isSuccess(completeRes)) {
            throw apiError(completeRes, 'Unable to complete multipart upload.');
          }
          multipartUploads[fieldKey].completed = true;
          return multipartUploads[fieldKey].uploadToken;
        });
      });
    }

    function uploadSingleFile(fieldKey, file, mime, runId) {
      var body = uploadSessionPayload();
      body.file = fileMetadata(file, mime);
      body.fieldKey = fieldKey;
      return api().requestPresignedUrl(root.dataset.apiBase || '', body, getHeaders()).then(function (res) {
        var data = res && res.body && res.body.data;
        if (!api().isSuccess(res) || !data || !data.uploadUrl || !data.uploadToken) {
          throw apiError(res, 'Unable to prepare upload.');
        }
        var label = config.progressUploading || 'Uploading your model… Large files may take several minutes.';
        showProgress(fieldKey, label, 0, runId);
        return scheduleOssUpload(function () {
          if (runId != null && runId !== uploadRunId) {
            return Promise.reject(new Error('Upload cancelled'));
          }
          return api().uploadToOss(data.uploadUrl, file, mime, file.size, function (loaded, total) {
            showProgress(fieldKey, label, total ? (loaded / total) * 100 : 0, runId);
          });
        }, fieldKey === 'modelFile' ? 0 : 1).then(function () {
          return data.uploadToken;
        });
      });
    }

    function uploadField(fieldKey, concurrency, runId) {
      var file = selectedFiles[fieldKey];
      if (!file) return Promise.resolve('');
      var mime = resolveMime(file);
      showProgress(fieldKey, config.progressPreparing || 'Preparing upload…', 0, runId);
      if (file.size >= MULTIPART_THRESHOLD_BYTES) {
        return uploadMultipartFile(fieldKey, file, mime, concurrency, runId);
      }
      return uploadSingleFile(fieldKey, file, mime, runId);
    }

    function mapSubmitFieldError(code, msg) {
      if (code === '1060000066') {
        setFieldError('companyName', msg || config.errCompanyRequired || 'Please enter your company name.');
        return true;
      }
      if (code === '1060000065' || code === '1060000064') {
        setFieldError('file', msg || config.errFileRequired || 'Please upload your 3D model file.');
        return true;
      }
      if (code === '1060000067') {
        setFieldError('file2', msg || config.errFile2Required || 'Please upload 3D Model File 2.');
        return true;
      }
      if (code === '1060000069') {
        setFieldError('file2', msg || config.errFilesDifferent || 'Please upload two different model files.');
        return true;
      }
      return false;
    }

    function submitWithUploadTokens(tokens) {
      var body = {
        authToken: session.authToken,
        storeCode: session.storeCode,
        orderEmail: session.orderEmail,
        fullName: fieldValue('fullName'),
        contactEmail: fieldValue('contactEmail'),
        countryCode: fieldValue('country'),
        addressLine1: fieldValue('addressLine1'),
        addressLine2: fieldValue('addressLine2') || undefined,
        city: fieldValue('city'),
        stateProvince: fieldValue('stateProvince'),
        postalCode: fieldValue('postalCode'),
        uploadToken: tokens.modelFile
      };
      var companyName = fieldValue('companyName');
      if (companyName) body.companyName = companyName;
      if (isBenefitB()) body.uploadToken2 = tokens.modelFile2;
      return api().submitSample(root.dataset.apiBase || '', body, getHeaders());
    }

    function onSubmit() {
      if (busy) return;
      if (!requireApi()) return;
      clearErrors();
      if (sessionExpired()) {
        resetSession();
        setStep(1);
        setBanner(config.errExpired || 'Your session has expired. Please verify your email again.');
        return;
      }
      if (!session.benefitType) {
        setBanner(config.errBenefit || 'Unable to determine your package. Please contact customer support.');
        setStep(1);
        return;
      }
      if (!validateStep2()) return;
      if (!allAgreesChecked()) {
        setStep(2);
        setFieldError('agree', config.errAgree || 'Please read and agree to the agreement before continuing.');
        return;
      }

      var keys = activeFieldKeys();
      // 必填 File1 多分并发；File2 少分；连接池内 File1 任务优先出队
      var concurrencyByKey = {};
      if (keys.length > 1) {
        concurrencyByKey.modelFile = Math.max(3, Math.ceil(MULTIPART_CONCURRENCY * 2 / 3));
        concurrencyByKey.modelFile2 = Math.max(1, MULTIPART_CONCURRENCY - concurrencyByKey.modelFile);
      } else if (keys[0]) {
        concurrencyByKey[keys[0]] = MULTIPART_CONCURRENCY;
      }
      uploadRunId += 1;
      var runId = uploadRunId;
      setBusy(true);
      window.addEventListener('beforeunload', warnLeave);

      Promise.all(
        keys.map(function (key) {
          return uploadField(key, concurrencyByKey[key] || MULTIPART_CONCURRENCY, runId).then(function (token) {
            if (token) {
              showProgress(
                key,
                config.progressComplete || 'Upload complete.',
                100,
                runId
              );
            }
            return { key: key, token: token };
          });
        })
      ).then(function (results) {
        var tokens = {};
        results.forEach(function (item) {
          tokens[item.key] = item.token;
        });
        if (isBenefitB() && (!tokens.modelFile || !tokens.modelFile2)) {
          throw new Error(config.errFile2Required || 'Please upload 3D Model File 2.');
        }
        if (isBenefitB() && tokens.modelFile === tokens.modelFile2) {
          throw new Error(config.errFilesDifferent || 'Please upload two different model files.');
        }
        showProgress('modelFile', config.progressSubmitting || 'Upload complete. Submitting…', 100, runId);
        if (isBenefitB()) {
          showProgress('modelFile2', config.progressSubmitting || 'Upload complete. Submitting…', 100, runId);
        }
        return submitWithUploadTokens(tokens);
      }).then(function (submitRes) {
        window.removeEventListener('beforeunload', warnLeave);
        setBusy(false);
        if (!api().isSuccess(submitRes)) {
          if (handleExpired(submitRes)) return;
          var code = envelopeCode(submitRes);
          var msg = envelopeMsg(submitRes);
          if (!mapSubmitFieldError(code, msg)) setBanner(msg);
          return;
        }
        clearErrors();
        multipartUploads.modelFile = null;
        multipartUploads.modelFile2 = null;
        resetSession();
        hideProgress();
        showSuccessModal();
      }).catch(function (err) {
        window.removeEventListener('beforeunload', warnLeave);
        // 作废本轮，丢弃迟到的进度回调；保留已完成字段的进度条
        uploadRunId += 1;
        setBusy(false, { keepProgress: true });
        abortAllMultipart();
        if (err && err.apiResult && handleExpired(err.apiResult)) return;
        if (err && err.apiResult && mapSubmitFieldError(envelopeCode(err.apiResult), envelopeMsg(err.apiResult))) {
          return;
        }
        var msg = err && err.message ? String(err.message) : '';
        if (msg === 'Upload cancelled') {
          msg = config.errNetwork || 'Network error. Please try again.';
        }
        setBanner(msg || config.errNetwork || 'Network error. Please try again.');
      });
    }

    function bindUploadSlot(fieldKey, errorKey) {
      var fileInput = q(root, '[data-cj270-file-input="' + fieldKey + '"]');
      var dropzone = q(root, '[data-cj270-dropzone="' + fieldKey + '"]');
      if (fileInput) {
        fileInput.multiple = false;
        fileInput.removeAttribute('multiple');
        fileInput.addEventListener('change', function () {
          var file = fileInput.files && fileInput.files[0];
          if (!file) {
            setFieldError(errorKey, '');
            setFile(fieldKey, null);
            return;
          }
          var err = validateFile(file);
          if (err) {
            setFieldError(errorKey, err);
            fileInput.value = '';
            setFile(fieldKey, null);
            return;
          }
          setFieldError(errorKey, '');
          setFile(fieldKey, file);
          if (
            isBenefitB() &&
            selectedFiles.modelFile &&
            selectedFiles.modelFile2 &&
            fileFingerprint(selectedFiles.modelFile) === fileFingerprint(selectedFiles.modelFile2)
          ) {
            setFieldError('file2', config.errFilesDifferent || 'Please upload two different model files.');
          }
        });
      }
      if (dropzone) {
        ['dragenter', 'dragover'].forEach(function (type) {
          dropzone.addEventListener(type, function (e) {
            e.preventDefault();
            dropzone.classList.add('is-dragover');
          });
        });
        ['dragleave', 'drop'].forEach(function (type) {
          dropzone.addEventListener(type, function (e) {
            e.preventDefault();
            dropzone.classList.remove('is-dragover');
          });
        });
        dropzone.addEventListener('drop', function (e) {
          if (busy) return;
          var file = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
          if (!file) return;
          var err = validateFile(file);
          if (err) {
            setFieldError(errorKey, err);
            return;
          }
          if (fileInput) fileInput.value = '';
          setFieldError(errorKey, '');
          setFile(fieldKey, file);
          if (
            isBenefitB() &&
            selectedFiles.modelFile &&
            selectedFiles.modelFile2 &&
            fileFingerprint(selectedFiles.modelFile) === fileFingerprint(selectedFiles.modelFile2)
          ) {
            setFieldError('file2', config.errFilesDifferent || 'Please upload two different model files.');
          }
        });
      }
    }

    if (storeTrigger) {
      // 委托 + capture：避免主题全局 click / 子元素挡住导致点不开
      root.addEventListener(
        'click',
        function (e) {
          var trigger = e.target && e.target.closest
            ? e.target.closest('[data-cj270-store-trigger]')
            : null;
          if (!trigger || !root.contains(trigger)) return;
          if (currentStep !== 1) return;
          e.preventDefault();
          e.stopPropagation();
          toggleStore();
        },
        true
      );
      storeTrigger.addEventListener(
        'keydown',
        function (e) {
          if (e.key !== 'Enter' && e.key !== ' ') return;
          e.preventDefault();
          toggleStore();
        }
      );
    }
    storeOptions.forEach(function (opt) {
      opt.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        setStoreSelection(opt.dataset.value, opt.dataset.label || opt.textContent);
        closeStore();
        setFieldError('store', '');
      });
    });

    if (countryTrigger) {
      countryTrigger.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        toggleCountry();
      });
    }
    if (countrySearch) {
      countrySearch.addEventListener('input', function () {
        filterCountries(countrySearch.value);
      });
      countrySearch.addEventListener('click', function (e) {
        e.stopPropagation();
      });
      countrySearch.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          e.preventDefault();
          closeCountry();
          if (countryTrigger) countryTrigger.focus();
        } else if (e.key === 'Enter') {
          e.preventDefault();
          selectFirstVisibleCountry();
        }
      });
    }
    document.addEventListener('click', function (e) {
      if (successModal && !successModal.hidden) return;
      if (storeWrap && storeWrap.classList.contains('is-open') && !storeWrap.contains(e.target)) {
        closeStore();
      }
      if (countryWrap && countryWrap.classList.contains('is-open') && !countryWrap.contains(e.target)) {
        closeCountry();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (successModal && !successModal.hidden) {
        hideSuccessModal();
        clearAgreeBoxes();
        syncAgreeButton();
        setStep(1);
        return;
      }
      closeStore();
      closeCountry();
    });

    bindUploadSlot('modelFile', 'file');
    bindUploadSlot('modelFile2', 'file2');

    if (acceptBtn) acceptBtn.addEventListener('click', onAccept);
    agreeBoxes.forEach(function (box) {
      box.addEventListener('change', function () {
        if (allAgreesChecked()) setFieldError('agree', '');
        syncAgreeButton();
      });
    });
    qa(root, '[data-cj270-success-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        hideSuccessModal();
        clearAgreeBoxes();
        syncAgreeButton();
        setStep(1);
      });
    });
    if (confirmBtn) confirmBtn.addEventListener('click', onConfirm);
    backBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (busy) return;
        clearErrors();
        if (currentStep === 3) setStep(2);
        else if (currentStep === 2) setStep(1);
      });
    });
    if (submitBtn) submitBtn.addEventListener('click', onSubmit);
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (currentStep === 1) onConfirm();
        else if (currentStep === 2) onAccept();
        else if (currentStep === 3) onSubmit();
      });
    }

    applyBenefitUI();
    setStep(1);
    syncAgreeButton();
    hideSuccessModal();
    setBusy(false);
    closeStore();
    closeCountry();
  }

  function globalApi() {
    return window.SZ_CJ270_SAMPLE_API;
  }

  function boot() {
    qa(document, '[data-sz-26-cj270-sample]').forEach(init);
  }

  function bootWhenReady() {
    boot();
    if (!globalApi()) {
      var tries = 0;
      var timer = setInterval(function () {
        tries += 1;
        if (globalApi() || tries > 40) clearInterval(timer);
        // API late-load：已 init 的 root 不用重绑；仅保证后续请求能取到 API
      }, 50);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootWhenReady);
  } else {
    bootWhenReady();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;
    var root = event.target.querySelector('[data-sz-26-cj270-sample]');
    if (root) {
      root.dataset.cj270Ready = '';
      init(root);
    }
  });
})();
